import { OrderByFields } from "./pagination-types"

export enum FilterType {
  TEXT = 'text',
  SELECT = 'select',
  DATE_RANGE = 'date-range',
  SORT = 'sort',
  ORDER = 'order',
  CHECKBOX = 'checkbox'
}


export interface FilterOption {
  icon?: any
  label: string
  value: string | number | boolean
  image?: string
  checked?: boolean
  id?: string
  name?: string
  slug?: string
  direction?: 'asc' | 'desc'
  orderBy?: OrderByFields

}

export interface FilterParams {
  page: number | string;
  take: number | string;
  order: 'asc' | 'desc';
  sortBy?: string;
  search?: string;
  status?: string;
  category?: string;
  dateFrom?: string;
  dateTo?: string;
  priceRange?: string;
  tag?: string | string[];
  rating?: string;
  inStock?: boolean | string;
  onSale?: boolean | string;
  featured?: boolean | string;
}

export interface FilterConfig<T> {
  key: string
  type: FilterType
  label: string
  placeholder?: string
  value?: any
  defaultValue?: any
  multiple?: boolean
  options?: FilterOption[]
  config?: T
  helperText?: string
}

export interface FilterProps<T> {
  config: FilterConfig<T>[]
  className?: string
  showClearButton?: boolean
}
